module.exports = __webpack_public_path__ + "img/client-1.ba876ba1.png";